import React from 'react';
import styled from 'styled-components/macro';
import frontEndInfo from '../../../package.json';

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  flex-shrink: 0;
  height: 10px;
`;

const TextVersion = styled.p`
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

const { REACT_APP_SHORT_SHA: SHORT_SHA, REACT_APP_SHA: SHA, NODE_ENV } = process.env;
const REPO_URL = 'https://bitbucket.org/ecslucystar/lucy4fe/commits/';

const RepoLink = (
  <a target="_blank" rel="noopener noreferrer" href={REPO_URL + SHA}>
    ({SHORT_SHA})
  </a>
);

interface MenuFooterProps {
  beBuildNumber: string | number;
  onChangelogClick: () => void;
  isMenuOpen?: boolean;
}

const MenuFooter: React.FC<MenuFooterProps> = ({ beBuildNumber, onChangelogClick, isMenuOpen }) => {
  return (
    <Footer>
      {isMenuOpen && (
        <span onClick={onChangelogClick}>
          <TextVersion>
            FE: {frontEndInfo.version}
            {NODE_ENV !== 'development' && RepoLink} BE: {beBuildNumber}
          </TextVersion>
        </span>
      )}
    </Footer>
  );
};

export default MenuFooter;
